<template id="dialog">
        <div class="dialog" v-if="showDialog">
            <div class="dialog_mask"></div>

            <div class="dialog_container">
                 <div class='container'>
                  <div class='close'  @click='closeDialog'></div>
                  <div class='title'>

                      <div class='close_alarm_style' @click='close_alarm'>解除报警</div>
                        
                  </div>
                  <!-- 工业品 -->
                    <div class='content' v-if='productNo=="2"?true:false'>
                      <div class="content_left">
                          <dialogLeft :dialogData ='mes_data' :position_item ='position_item' :productType = productNo></dialogLeft>
                      </div>
                      <div class="content_center">
                          <dialogCenter :dialogData ='alarm_detail' :deviceData ='device_data' :productType = productNo></dialogCenter>
                      </div>
                      <div class="content_right">
                          <dialogRight :dialogData ='pres_data' :picTures ='pictrue'></dialogRight>
                      </div> 
                  </div>
                  <!-- 民品 -->
                  <div class='civilian_products'  v-if='productNo=="1"?true:false'>
                      <dialogCivilian :productType= productNo :dialogData ='dialogData'></dialogCivilian>
                  </div>
                  <!-- 工商品 -->
                  <div v-if='productNo=="3"?true:false'>
                      <dialogIndustrial :productType= productNo :dialogData ='dialogData'></dialogIndustrial>
                  </div>
                  <!-- 通化产品 -->
                  <div class='content1' v-if='productNo=="4"?true:false'>
                       <div class="content_left1">
                          <dialogLeft :dialogData ='mes_data' :position_item ='position_item' :productType = productNo></dialogLeft>
                      </div>
                      <div class="content_center1">
                          <dialogCenter :dialogData ='alarm_detail' :deviceData ='device_data' :productType = productNo></dialogCenter>
                      </div>
                      <div class="content_right1">
                          <dialogRight :dialogData ='pres_data' :picTures ='pictrue'></dialogRight>
                      </div>
                  </div>
                 </div>
            </div>
        </div>
</template>
<script>
import dialogLeft from './dialog_left'
import dialogRight from './dialog_right'
import dialogCenter from './dialog_center'
import dialogCivilian from './dialog_civilian'
import dialogIndustrial from './dialog_industrial'
// import dialogAlarmlist from './dialog_alarmlist'
import Chart from '../../components/chart/LineMarker.vue'
export default {
  props: {
        showDialog: {
            type: Boolean,
            default: false
        },
        dialogData:{
            type:Object,
            default:()=>{}
        },
        productType:{
            type:String,
            default:''
        },
        

      },
    data(){
        return{
            mes_data:{},
            device_data:{},
            pres_data:{},
            alarm_detail:{},
            position_item:[],
            productNo:'',
            pictrue:[],
        }
    },
    components:{
        dialogLeft,
        dialogRight,
        dialogCenter,
        dialogCivilian,
        dialogIndustrial,
        Chart
    },
    mounted(){
    },
    watch:{
        dialogData:{
            handler:function(newVal,oldVal){
                console.log('数据过来了dialogdata-=-=-=-=-=-=-=')
                this.pageInit()
            },
            deep:true
        },showDialog:{
            handler:function(newVal,oldVal){
                if(newVal){
                // this.openFullScreen2()
                }
             },
            deep:true
        },
        
    },
    methods:{ 
        closeDialog(){
            this.$emit('closeDialog')
        },
        close_alarm(){
            this.$emit('close_alarm')
        },
        pageInit(){
            // this.alarm_detail = this.$deepClone(this.dialogData.alarmDetailData);
            // this.mes_data  = this.$deepClone(this.dialogData.mesData);
            // this.pres_data = this.$deepClone(this.dialogData.presData);
            // this.device_data = this.$deepClone(this.dialogData.deviceData);
            // this.position_item = this.$deepClone(this.dialogData.alarmDetailData.position);
            // this.productNo = this.$deepClone(this.dialogData.alarmDetailData.productNo);
            // this.pictrue = this.$deepClone(this.dialogData.alarmDetailData.picture);

            this.productNo = '1';
        //   console.log('alarm_detail-=-=-='+JSON.stringify(this.alarm_detail)+'mes_data-=-=-=-='+JSON.stringify(this.mes_data)+'pres_data-=-=-='+JSON.stringify(this.pres_data)+'device_data-=-=-=-='+JSON.stringify(this.device_data)+'position_item-=-=-=-'+JSON.stringify(this.position_item)+'productNo-=-=-=-'+JSON.stringify(this.productNo))
        }
    }
}
</script>
<style lang="less" scoped>
           //修改单个的选项的样式
  
// & /deep/   .el-button--primary {
//     color: rgb(241, 241, 241);
//     background-color:rgba(12, 174, 238,1);
//   }
.dialog{
    .dialog_mask{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.9);
        z-index:10;
    }

    .container{
        width: 70%;
        height: 88%;
        position: fixed;
        top: 5%;
        left: 0px;
        right: 0px;
        margin-left:auto;
        margin-right:auto;
        z-index: 10;
        // background:url(../../../static/img/er_bg.png) no-repeat;
        background:url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/er_bg.png) no-repeat;
        background-position: 100% 100%;
        background-size: 100% 95%;
        z-index: 999;
        .close{
            width: 35px;
            height: 35px;
            cursor: pointer;
            margin-left: 95%;
            margin-bottom: 10px;
            // height: 20px;
            // background: url(../../../static/img/close.png) no-repeat;
            background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/close.png) no-repeat;
            background-size: 100% 100%;
            z-index: 10;

        }
        .title{
            height: 65px;
            // background: url(../../../static/img/er_title.png);
            background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/er_title.png) no-repeat;
            background-size: 100% 100%;

            .close_alarm_style{
                width: 32%;
                text-align: right;
                line-height: 3;
                margin-left: 800px;
                color: red;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
                float: right;
                padding-right: 20px;
            }
            .group_button{
                 position: absolute;
                 top: 13%;
                 left: 42%;

            }
  

        }
        .content{
            width:100%;
            height: 87%;
            // overflow:hidden;
            // background:url(../../../static/img/er_bg.png) no-repeat;
            // background-position: 100% 100%;
            // padding-top: 45px;
            .content_left{
                position: relative;
                width:30%;
                height: 100%;
                padding-top: 15px;
                float: left;

            }
            .content_center{
                position: absolute;
                width:40%;
                height: 80%;
                left: 31%;
                top: 15%;
            }
            .content_right{
                position: absolute;
                width:30%;
                height: 87%;
                padding-top: 15px;
                  right: 0px;
            //   background-color: sandybrown;


            }
            

        }
         .content1{
            width:100%;
            height: 705px;
            overflow:hidden;
            // background:url(../../../static/img/er_bg.png) no-repeat;
            // background-position: 100% 100%;
            padding-top: 45px;
           
            .content_left1{
                width:25%;
                height: 560px;
                float:left;
                padding-top: 15px;
            }
            .content_center1{
                width:50%;
                height: 560px;
                // background:yellow;
                float:left;
            }
            .content_right1{
                width:25%;
                height: 560px;
                // background:red;
                float:right;
                padding-top: 15px;
            }


        }
        .inpresgifWrapper{
            text-align: center;
            margin: 0 auto;
            width: 400px;
            height: 28px;
            position: relative;
            top: 48%;
            left: 50%;
            margin-top: -14px;
            margin-left: -200px;
            display: flex;
            justify-content: space-between;
            img{
                width: 40px;
                height: 20px;
                margin-top: 5px;
            }
        }
       
       .chartline{
                position: absolute;
                top: 20%;
            }
    }
    .dialog_content_top{
        height: 63px;
        // background: url(../../../static/img/er_title.png) no-repeat;
        background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/er_title.png) no-repeat;
        background-size: 100% 100%;
    }
  
}
 
  
</style>




// WEBPACK FOOTER //
// src/components/dialog/dialogs.vue